import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUser, getAdminViewMode } from "@/lib/api";

// Se já existe sessão salva, calcula pra onde o usuário logado deveria ir —
// paciente sempre vai pro Portal (/paciente), médico/admin pro painel deles.
export function destinoLogado(): string | null {
  const user = getUser<{ role?: string }>();
  if (!user) return null;
  if (user.role === "patient") return "/paciente";
  if (user.role === "marketing") return "/marketing";
  if (user.role === "nutricionista" || user.role === "secretaria" || user.role === "financeiro") return "/admin";
  return user.role === "admin" ? (getAdminViewMode() === "doctor" ? "/medico" : "/admin") : "/medico";
}

// Hook pra páginas "públicas" (Home, /acessar) que não fazem sentido pra quem já
// está logado — redireciona pro destino certo assim que a página monta, sem
// depender de onde a navegação veio (clique de link, botão Voltar do navegador/
// iOS, digitação direta da URL). Resolve o bug de "sessão escondida": token válido
// salvo, mas a rota pública agia como se ninguém estivesse logado.
export function useRedirectIfLoggedIn() {
  const navigate = useNavigate();
  useEffect(() => {
    const destino = destinoLogado();
    if (destino) navigate(destino, { replace: true });
  }, []);
}
